import {Action} from '@ngrx/store';
import {UserSettings} from '../../global/user-settings.dto';

export enum UserSettingsActionTypes {
  UPDATE_USER_SETTINGS = '[User] ADD USER SETTINGS',
  REFRESH_USER_AVATAR = '[User] REFRESH USER AVATAR',
  START_USER_INACTIVITY_DETECTION ='[User] START USER INACTIVITY DETECTION',
  STOP_USER_INACTIVITY_DETECTION ='[User] STOP USER INACTIVITY DETECTION',
  CLEAR_STATE = '[User] CLEAR STATE',  
}
/**
 * action for the user
 */
export class ADD_USER_SETTINGS implements Action {
  readonly type = UserSettingsActionTypes.UPDATE_USER_SETTINGS;
  constructor(public payload: Partial<UserSettings>) { }
}

export class CLEAR_STATE implements Action {
    readonly type = UserSettingsActionTypes.CLEAR_STATE;
}

export class REFRESH_USER_AVATAR implements Action {
    readonly type = UserSettingsActionTypes.REFRESH_USER_AVATAR;
    constructor() { }
}

export class START_USER_INACTIVITY_DETECTION implements Action {
    readonly type = UserSettingsActionTypes.START_USER_INACTIVITY_DETECTION;
    constructor() { }
}

export class STOP_USER_INACTIVITY_DETECTION implements Action {
    readonly type = UserSettingsActionTypes.STOP_USER_INACTIVITY_DETECTION;
    constructor() { }
}
